<template>
	<label class="form-input">
		<input :name="label.replace(' ', '_').toLowerCase()" :maxlength="maxLength" :class="{'has-value': value}" ref="input" @input="update()" :type="type" :value="value" :required="required" :disabled="disabled">
		<span class="label-text">{{ label }}</span>
	</label>
</template>
<script>
	export default {
		props: ['label', 'type', 'value', 'disabled', 'required', 'maxLength'],
		methods: {
			update() {
				this.$emit('input', this.$refs.input.value)
			}
		}
	}
</script>
